import * as React from 'react';
import styled from 'styled-components';
import { PromotionalPrice } from '@ids/types/contentful';
import Text from '@ids/components/Typography/Text';
import { Maybe } from '@ids/types/utility';

const Price = styled(Text).attrs(() => ({ as: 'div' }))`
    margin-bottom: 20px;
`;

export const usePrice = (promotionalPrice?: Maybe<PromotionalPrice>, price?: string) => {
    if (!promotionalPrice?.price && !price) {
        return null;
    }

    if (!promotionalPrice?.price) {
        return price;
    }

    const now = Date.now();
    const startDate = new Date(promotionalPrice.startDate).getTime();
    const endDate = new Date(promotionalPrice.endDate).getTime();

    if (startDate < now && endDate > now) {
        // eslint-disable-next-line react/no-danger
        return <div dangerouslySetInnerHTML={{ __html: promotionalPrice.price }} />;
    }

    return price;
};

export default Price;
